import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../Layout/Main/header/Header";
import Footer from "../../Layout/Main/footer/FooterTwo";

class Tips extends Component{
    render(){
        let title = 'Furniture Moving';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Packing' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-12">
                                    <div className="about-inner inner">
                                <Breadcrumb title={'Furniture Moving'}   />
                                        <div className="section-title">
                                            <h2 className="title text-center">{title}</h2>
                                            <p className="description text-left pt--50"><a href="/"><b>Moonline</b></a> is one of the top furniture moving companies in Canada. If you are planning to move to another place or you are planning to re-locate then have you ever thought of how you are going to move your heavy furniture like a refrigerator, washer, or dryer? how you’ll bring down a 3 seat sofa from a tight stairway? how you are going to move other heavy furniture without damaging it?   </p>
                                            <p className="description text-left pt--10">Moving large and heavy furniture is not an easy task. It requires special equipment and special expertise to move large equipment. Therefore, it is better to hire a professional moving company to keep your mind at ease and to be sure that your furniture is transported from one place to another securely without any damage. At <a href="/"><b>Moonline</b></a>, we ensure that your furniture is handled with care and moved to your desired new location without any damage. As we are a certified and insured company so compensation would be provided if any damage occurs to furniture during your move.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-center">Why Choose Us?</h3>
                                            <p className="pt--20">There are plenty of moving companies operating in your surroundings, then you may be thinking what makes us different from others. The answer is simple yet shows why we are different than other local movers. Here are few points worth mentioning: </p>
                                        </div>
                                       
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">THE RIGHT TOOLS</h3>
                                                    <p>Moving furniture from one place to another requires special equipment. <a href="/"><b>Moonline</b></a> possess all the equipment and techniques that are required to move your furniture especially the heavy items from one place to another safely without any damage.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">SKILLED CREWS</h3>
                                                    <p>Skilled manpower is also essential for a moving company if they are moving the furniture of their clients to ensure security and efficiency. We have strong and capable staff to do this job. We also bring the ramps, dollies, and straps to help protect and secure your things. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">PREPARATION AND PROTECTION</h3>
                                                    <p>Moonline is an expert in planning the most efficient move for your furniture. We know the importance of your goods, therefore, we come up with the best techniques to move your furniture so that no damage is caused to your furniture and your property especially to the floors and walls. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">PROFESSIONAL PACKING</h3>
                                                    <p>We are also experts in packing. We know how to secure your goods by packing them perfectly. We possess all the equipment and tools that are required to pack your stuff and we make it quick and efficient to save your time and to make your move effortless. </p>
                                                    <p>So if you are looking for a professional company to move your home or office furniture then look no further because <a href="/"><b>Moonline</b></a> got you covered. You can easily reach out to us through our website or you can also <a href="/contact"><b>call us</b></a> to discuss and plan your move. Our packages are most affordable in town and we never compromise on the quality of service.</p>
                                                </div>
                                            </div>
                                        </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Tips;